// Force tippy at the route, should be in about > toolbox.tsx but due to lazy loading of components on pages > index.tsx this causes issues in Google Lighthouse
import "tippy.js/dist/tippy.css"
import "tippy.js/animations/shift-away.css"

// Force the page to reload once any cupdates to the service worker (assets) have been downlaoded and are ready
// TODO: Replace this with a snackbar prompt and reload (https://material-ui.com/components/snackbars/)
export const onServiceWorkerUpdateReady = () => console.log("updated app") // window.location.reload()
